module.exports = __webpack_public_path__ + "static/media/banner.605862d8.png";